export default {
  autoUpdate: 'Automatisch aktualisieren',
  updateInterval: 'Aktualisierungsintervall',
  lastUpdate: 'Letzte Aktualisierung',
  nextUpdate: 'Nächste Aktualisierung in {0}',
};
